import React, { useRef, useState } from "react";
import ActionsBar from "components/SubHeader/ActionsBar";
import SubHeader from "components/SubHeader";
import SubHeaderTitle from "components/SubHeader/SubHeaderTitle";
import { useTranslation } from "react-i18next";
import { netCall } from "utils/netCall";
import { ManagementApiUrl } from "environment/routeSettings";
import { TProvince } from "types/dto";
import { toast } from "react-toastify";
import { useURLTools } from "utils/URLtools";
import { AddSubscriberModal, TAddFormTypes } from "./AddSubscriberModal";
import { DataGridRef } from "devextreme-react/data-grid";
import WaterSubscribersGrid from "components/Grid/grids/WaterSubscribersGrid";
import { TWaterSubscribersGridRow } from "components/Grid/grids/WaterSubscribersGrid/types";
import { TResponseCode } from "utils/netCall/types";

const SubscribersView = () => {
  const { t } = useTranslation();
  const { queryParams, navigateWithQueryParams } = useURLTools();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const GridRef = useRef<DataGridRef<any, any>>(null);

  const onAddClick = () => {
    setAddModalOpen(true);
  };

  const onSubmitAddSubscribers = async (values: TAddFormTypes) => {
    setIsSubmitting(true);
    const res = await netCall<TProvince>({
      method: "POST",
      endPoint: `${ManagementApiUrl()}/api/WaterSubscriber/Add`,
      body: {
        ...values,
      },
    });
    if (res.responseCode === TResponseCode.OK) {
      setIsSubmitting(false);
      toast.success(t("operationSuccessful"));
      setAddModalOpen(false);
      GridRef.current?.instance().refresh();
    } else {
      setIsSubmitting(false);
      toast.error(t("operationFailed"));
    }
  };

  const onWaterSubscriberRowClick = (row: TWaterSubscribersGridRow) => {
    navigateWithQueryParams(`/dashboard/subscribers/details/${row.id}`, [], {
      replace: true,
    });
  };

  return (
    <>
      <SubHeader>
        <SubHeaderTitle>{t("subscribers")}</SubHeaderTitle>
        <ActionsBar
          requestTime={0}
          isLoading={false}
          actionButtons={[
            {
              iconName: "MdAdd",
              buttonTooltip: t("add"),
              action: onAddClick,
              permissions: ["superadmin", "d_watersubscriber"],
            },
          ]}
        />
      </SubHeader>
      <div className={"w-full flex gap-x h-[calc(100%-56px)]"}>
        <WaterSubscribersGrid
          enableDetailsContextMenu
          provinceId={queryParams?.provinceId}
          cityId={queryParams?.cityId}
          jurisdictionId={queryParams?.jurisdictionId}
          actionButtons={
            [
              // {
              //   icon: "fa-solid fa-pencil",
              //   hint: t("edit"),
              //   onClick: onEditClick,
              // },
            ]
          }
          isLoading={false}
          ref={GridRef}
          onRowClick={onWaterSubscriberRowClick}
        />
      </div>
      {addModalOpen && (
        <AddSubscriberModal
          onClose={() => setAddModalOpen(false)}
          isOpen={addModalOpen}
          onSubmit={onSubmitAddSubscribers}
          isLoading={isSubmitting}
        />
      )}
    </>
  );
};

export default SubscribersView;
